import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Table,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { pointRatesAPI } from "../../services/api"
import AlertModal from "../../components/Common/AlertModal"

const PointRates = (props) => {
    document.title = "Grille Tarifaire | Ticket Management"

    const [rates, setRates] = useState([])
    const [modal, setModal] = useState(false)
    const [editingRate, setEditingRate] = useState(null)
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState({
        level: "",
        rate: "",
    })

    const [alertConfig, setAlertConfig] = useState({
        isOpen: false,
        type: 'success',
        message: '',
        title: ''
    })

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Grille Tarifaire", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Points & Tarifs", breadcrumbItems)
        fetchRates()
    }, [])

    const fetchRates = async () => {
        try {
            const res = await pointRatesAPI.getAll()
            setRates(res.data)
        } catch (error) {
            console.error("Erreur chargement tarifs", error)
        }
    }

    const toggleModal = () => {
        setModal(!modal)
        if (!modal) {
            setEditingRate(null)
            setFormData({ level: "", rate: "" })
        }
    }

    const handleEdit = (rate) => {
        setEditingRate(rate)
        setFormData({
            level: rate.level,
            rate: rate.rate,
        })
        setModal(true)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            if (editingRate) {
                await pointRatesAPI.update(editingRate.id, formData)
                setAlertConfig({
                    isOpen: true,
                    type: 'success',
                    title: 'Succès',
                    message: 'Tarif mis à jour avec succès.'
                })
            } else {
                await pointRatesAPI.create(formData)
                setAlertConfig({
                    isOpen: true,
                    type: 'success',
                    title: 'Succès',
                    message: 'Nouveau tarif ajouté.'
                })
            }
            toggleModal()
            fetchRates()
        } catch (error) {
            console.error("Erreur enregistrement tarif", error)
            setAlertConfig({
                isOpen: true,
                type: 'error',
                title: 'Erreur',
                message: 'Une erreur est survenue.'
            })
        } finally {
            setLoading(false)
        }
    }

    const handleDelete = async (id) => {
        if (window.confirm("Voulez-vous vraiment supprimer ce tarif ?")) {
            try {
                await pointRatesAPI.delete(id)
                fetchRates()
            } catch (error) {
                console.error("Erreur suppression tarif", error)
            }
        }
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <CardTitle className="h4">Grille Tarifaire (Conversion Points vers DH)</CardTitle>
                                <Button color="primary" onClick={toggleModal}>
                                    <i className="mdi mdi-plus me-1"></i> Nouveau Palier
                                </Button>
                            </div>
                            <p className="text-muted">
                                Définissez ici la valeur en DH d'un point pour chaque niveau (Level).
                                Le système utilise ces taux pour calculer le cumul DH des collaborateurs.
                            </p>

                            <div className="table-responsive">
                                <Table className="table mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Level (Niveau)</th>
                                            <th>Taux (1 Point = X DH)</th>
                                            <th>Date de mise à jour</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rates.map((r) => (
                                            <tr key={r.id}>
                                                <td><span className="badge bg-soft-info text-info font-size-14">Level {r.level}</span></td>
                                                <td><strong>{parseFloat(r.rate).toFixed(2)} DH</strong></td>
                                                <td>{new Date(r.updated_at).toLocaleDateString()}</td>
                                                <td>
                                                    <Button color="light" size="sm" className="me-2" onClick={() => handleEdit(r)}>
                                                        <i className="mdi mdi-pencil text-primary"></i>
                                                    </Button>
                                                    <Button color="light" size="sm" onClick={() => handleDelete(r.id)}>
                                                        <i className="mdi mdi-trash-can text-danger"></i>
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>
                    {editingRate ? "Modifier le Tarif" : "Nouveau Tarif par Level"}
                </ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <ModalBody>
                        <FormGroup>
                            <Label for="level">Level</Label>
                            <Input
                                type="number"
                                id="level"
                                value={formData.level}
                                onChange={(e) => setFormData({ ...formData, level: e.target.value })}
                                required
                                disabled={editingRate}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for="rate">Taux (DH par Point)</Label>
                            <Input
                                type="number"
                                step="0.01"
                                id="rate"
                                value={formData.rate}
                                onChange={(e) => setFormData({ ...formData, rate: e.target.value })}
                                required
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal}>Annuler</Button>
                        <Button color="primary" type="submit" disabled={loading}>
                            {loading ? "Enregistrement..." : "Enregistrer"}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>

            <AlertModal
                isOpen={alertConfig.isOpen}
                toggle={() => setAlertConfig({ ...alertConfig, isOpen: false })}
                type={alertConfig.type}
                message={alertConfig.message}
                title={alertConfig.title}
            />
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(PointRates)
